import React, { Component } from "react";

import {
  CInputGroup,
  CButton,
  CInputRadio,
  CLabel,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CInput,
  CFormGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.css";

const FileDownload = require("js-file-download");

class EditNewton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // loading: true,
      // upload: null,
      // grade: null,
      name: props.newton.name,
      resume: props.newton.resume,
      status: props.newton.status,
      image: props.newton.image,
      module_code: props.newton.module_code
    };

    this.inputRef = React.createRef();
  }

  onSave() {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      module_code: this.state.module_code,
      resume: this.state.resume,
      image: this.state.image,
      status: this.state.status
    };

    axios
      .post(`${URL.api}content/los/update/${this.props.newton.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          toastr.success(
            "Simulador editado",
            "O simulador foi editado com sucesso!"
          );
          this.props.onClose();
        },
        error => {
          toastr.error("Falha", "Não foi possível editar o simulador!");
        }
      );
  }

  changeSelectedImage(selectedImage) {
    const file = new FormData();
    file.append("filepond", selectedImage);

    axios
      .post(`${URL.api}file/lo/${this.props.user.user.id}`, file, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ image: resp.data.url });
        }
      });
  }

  render() {
    return (
      <CModal
        onClose={this.props.onClose}
        show={this.props.show}
        centered
        size="md"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Editar Newton</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <input
              type="file"
              accept="image/jpg, image/png"
              hidden
              ref={this.inputRef}
              onChange={e => this.changeSelectedImage(e.target.files[0])}
            />
            <div
              className="newton-img-upload-container rounded mb-3"
              onClick={() => this.inputRef.current.click()}
            >
              <img
                src={URL.img + (this.state.image || "uploads/lo/noPicture.jpg")}
                alt="Simulador"
              />
              <div className="placeholder"></div>
            </div>
            <CFormGroup>
              <strong>Nome</strong>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="text"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                />
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <strong>Descrição</strong>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="text"
                  value={this.state.resume}
                  onChange={e => this.setState({ resume: e.target.value })}
                />
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <strong>Categoria</strong>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  type="text"
                  value={this.state.module_code}
                  onChange={e => this.setState({ module_code: e.target.value })}
                >
                  <option value="NEWTONELE">Elétrica</option>
                  <option value="NEWTONMEC">Mecânica</option>
                  <option value="NEWTONOND">Ondulatória</option>
                  <option value="NEWTONOPT">Óptica</option>
                  <option value="NEWTONTER">Termodinâmica</option>
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <strong>Status</strong>
              <CFormGroup variant="checkbox">
                <CInputRadio
                  className="form-check-input"
                  id="radio1"
                  name="radios"
                  checked={this.state.status === "Em produção"}
                  onChange={e =>
                    e.target.checked && this.setState({ status: "Em produção" })
                  }
                />
                <CLabel variant="checkbox" htmlFor="radio1">
                  Em produção
                </CLabel>
              </CFormGroup>
              <CFormGroup variant="checkbox">
                <CInputRadio
                  className="form-check-input"
                  id="radio2"
                  name="radios"
                  checked={this.state.status === "Homologado"}
                  onChange={e =>
                    e.target.checked && this.setState({ status: "Homologado" })
                  }
                />
                <CLabel variant="checkbox" htmlFor="radio2">
                  Homologado
                </CLabel>
              </CFormGroup>
              <CFormGroup variant="checkbox">
                <CInputRadio
                  className="form-check-input"
                  id="radio3"
                  name="radios"
                  checked={this.state.status === "Liberado"}
                  onChange={e =>
                    e.target.checked && this.setState({ status: "Liberado" })
                  }
                />
                <CLabel variant="checkbox" htmlFor="radio3">
                  Liberado
                </CLabel>
              </CFormGroup>
            </CFormGroup>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={() => this.onSave()}>
            Salvar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNewton);
